import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadAssetProfile, leadAssetProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const LEAD_ASSET_PROFILE_MODULE = 'leadAssetProfile';

const dataObjectModule = getDataObjectsModule<ILeadAssetProfile>(leadAssetProfilesManager);
const searchModule = getSearchModule<ILeadAssetProfile>(leadAssetProfilesManager);

const leadAssetProfileModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_ASSET_PROFILE_MODULE, leadAssetProfileModuleInstance);

export { LEAD_ASSET_PROFILE_MODULE };
